import React from 'react';
import { useScrollBehavior } from './hooks/useScrollBehavior';
import Header from './components/layout/Header/Header';
import Footer from './components/layout/Footer/Footer';
import Hero from './components/sections/Hero/Hero';
import About from './components/sections/About/About';
import Services from './components/sections/Services/Services';
import Values from './components/sections/Values/Values';
import Contact from './components/sections/Contact/Contact';
import './styles/brand.css';

function App() {
  const { scrolled, scrollToSection } = useScrollBehavior();

  return (
    <div className="min-h-screen bg-white">
      <Header scrolled={scrolled} scrollToSection={scrollToSection} />
      <Hero scrollToSection={scrollToSection} />
      <About />
      <Services />
      <Values />
      <Contact />
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}

export default App;
